import { Box, styled } from '@mui/material';

export type LuggageIndicatorProps = {
  small?: boolean;
  medium?: boolean;
  large?: boolean;
};

export const GreenHandbag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
    <path
      d="M6.25 14C5.90625 14 5.61188 13.8824 5.36688 13.6472C5.12188 13.412 4.99958 13.1296 5 12.8V5.6C5 5.04 5.17708 4.55 5.53125 4.13C5.88542 3.71 6.33333 3.43 6.875 3.29V2H8.75V3.2H11.25V2H13.125V3.29C13.6667 3.43 14.1146 3.71 14.4688 4.13C14.8229 4.55 15 5.04 15 5.6V12.8C15 13.13 14.8775 13.4126 14.6325 13.6478C14.3875 13.883 14.0933 14.0004 13.75 14H6.25ZM11.5625 10.4H12.8125V8H7.1875V9.2H11.5625V10.4Z"
      fill="#4CAF50"
    />
  </svg>
);

export const GreenCarryOn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 12H17C18.1 12 19 12.9 19 14V19C19 20.1 18.1 21 17 21C17 21.55 16.55 22 16 22C15.45 22 15 21.55 15 21H9C9 21.55 8.55 22 8 22C7.45 22 7 21.55 7 21C5.9 21 5 20.1 5 19L5 14C5 12.9 5.9 12 7 12H9V3C9 2.45 9.45 2 10 2H14C14.55 2 15 2.45 15 3V12ZM10.5 12H13.5V3.5H10.5V12ZM8 17V15.5H16V17H8Z"
      fill="#4CAF50"
    />
  </svg>
);

export const GreenSuitcase = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M17 6H15V3C15 2.45 14.55 2 14 2H10C9.45 2 9 2.45 9 3V6H7C5.9 6 5 6.9 5 8V19C5 20.1 5.9 21 7 21C7 21.55 7.45 22 8 22C8.55 22 9 21.55 9 21H15C15 21.55 15.45 22 16 22C16.55 22 17 21.55 17 21C18.1 21 19 20.1 19 19V8C19 6.9 18.1 6 17 6ZM9.5 18H8V9H9.5V18ZM12.75 18H11.25V9H12.75V18ZM13.5 6H10.5V3.5H13.5V6ZM16 18H14.5V9H16V18Z"
      fill="#4CAF50"
    />
  </svg>
);

export const GreyCarryOn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0002 16.1715V14C19.0002 12.9 18.1002 12 17.0002 12H15.0002V3C15.0002 2.45 14.5502 2 14.0002 2H10.0002C9.45016 2 9.00016 2.45 9.00016 3V6.17149L10.5002 7.67149V3.5H13.5002V10.6715L19.0002 16.1715ZM10.5002 10.4999V10.5L12.0002 12H12.0002L15.5002 15.5H15.5002L16.0002 16V15.9999L19.0002 18.9999V19L21.3849 21.3848L19.9707 22.799L17.9371 20.7654C17.6572 20.915 17.3381 21 17.0002 21C17.0002 21.55 16.5502 22 16.0002 22C15.4502 22 15.0002 21.55 15.0002 21H9.00016C9.00016 21.55 8.55016 22 8.00016 22C7.45016 22 7.00016 21.55 7.00016 21C5.90016 21 5.00016 20.1 5.00016 19V14C5.00016 12.9 5.90016 12 7.00016 12H9.00016V11.8284L1.58594 4.4142L3.00015 2.99999L9.00016 9V8.99992L10.5002 10.4999ZM8.00016 15.5H12.6717L14.1717 17H8.00016V15.5Z"
      fill="#E0E0E0"
    />
  </svg>
);

export const GreySuitcase = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0002 16.1715V8C19.0002 6.9 18.1002 6 17.0002 6H15.0002V3C15.0002 2.45 14.5502 2 14.0002 2H10.0002C9.45016 2 9.00016 2.45 9.00016 3V6H8.82867L11.8287 9H12.7502V9.92149L14.5002 11.6715V9H16.0002V13.1715L19.0002 16.1715ZM14.5002 14.4999V14.5L16.0002 16V15.9999L19.0002 18.9999V19L21.3849 21.3848L19.9707 22.799L17.9371 20.7654C17.6572 20.915 17.3381 21 17.0002 21C17.0002 21.55 16.5502 22 16.0002 22C15.4502 22 15.0002 21.55 15.0002 21H9.00016C9.00016 21.55 8.55016 22 8.00016 22C7.45016 22 7.00016 21.55 7.00016 21C5.90016 21 5.00016 20.1 5.00016 19V8C5.00016 7.94453 5.00245 7.88957 5.00694 7.83521L1.58594 4.4142L3.00015 2.99999L6.17802 6.17786C6.17803 6.17785 6.17805 6.17784 6.17807 6.17783L9.00024 9H9.00016L9.50016 9.5V9.49992L11.2502 11.2499V11.25L12.7502 12.75V12.7499L14.5002 14.4999ZM8.00016 18V10.8284L9.50016 12.3284V18H8.00016ZM11.2502 18V14.0784L12.7502 15.5784V18H11.2502ZM14.5002 18V17.3284L15.1717 18H14.5002ZM13.5002 6H10.5002V3.5H13.5002V6Z"
      fill="#E0E0E0"
    />
  </svg>
);

const Boxed = styled(Box)`
  height: 24px;
`;

const Boxee = styled(Box)`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
`;

export const LuggageIndicator = ({ small = true, medium = false, large = false }: LuggageIndicatorProps) => (
  <Boxed display="flex" justifyItems="center">
    <Boxee sx={{ width: '0.8rem' }}>{small ? <GreenHandbag /> : <GreenHandbag />}</Boxee>
    <Boxee sx={{ width: '1.1rem' }}>{medium ? <GreenCarryOn /> : <GreyCarryOn />}</Boxee>
    <Boxee sx={{ width: '1.1rem' }}>{large ? <GreenSuitcase /> : <GreySuitcase />}</Boxee>
  </Boxed>
);
